import { render } from "./PhoneMange.vue?vue&type=template&id=cfbfd6ea&scoped=true"
import script from "./PhoneMange.vue?vue&type=script&lang=js"
export * from "./PhoneMange.vue?vue&type=script&lang=js"

import "./PhoneMange.vue?vue&type=style&index=0&id=cfbfd6ea&lang=scss&scoped=true"
import "./PhoneMange.vue?vue&type=style&index=1&id=cfbfd6ea&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfbfd6ea"]])

export default __exports__